/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeEvent, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ClassesEnum } from "@/ts/enums/ClassesEnum";
import { getTrackingId } from "@/utils/utils";

import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input
} from "@chakra-ui/react";

import { CreateStudentFormDataInterface } from "@ts/interfaces/Enrol/StudentEntrolInterface";

interface Props {
    errors: any;
    touchedFields: any;
}

const CreateStudentForm = ({ errors, touchedFields }: Props) => {
    const { t } = useTranslation();
    const { register, trigger, setValue } = useFormContext();

    const handleChange = (
        e: ChangeEvent<HTMLInputElement>,
        setValue: (
            name: keyof CreateStudentFormDataInterface,
            value: any,
            options?: any
        ) => void
    ) => {
        const { name, value } = e.target;

        setValue(name as keyof CreateStudentFormDataInterface, value, {
            shouldValidate: true
        });
    };

    useEffect(() => {
        trigger("firstName");
        trigger("lastName");
    }, [trigger, setValue]);

    return (
        <>
            <FormControl
                isInvalid={!!errors.firstName && touchedFields["firstName"]}
                className={ClassesEnum.FormField}
                data-tracking-id={getTrackingId(
                    [ClassesEnum.FormField],
                    "studentFirstNameLabel"
                )}
            >
                <FormLabel>
                    {t(
                        "enrol.createStudentPage.firstNameLabel",
                        "Student's first name"
                    )}
                </FormLabel>
                <Input
                    id="firstName"
                    {...register("firstName")}
                    maxLength={50}
                    onChange={e => handleChange(e, setValue)}
                    data-testid="first-name-input"
                    className={ClassesEnum.Input}
                    data-tracking-id={getTrackingId(
                        [ClassesEnum.Input],
                        "studentFirstName"
                    )}
                />
                <FormErrorMessage>
                    {t(errors.firstName?.message as string)}
                </FormErrorMessage>
            </FormControl>
            <FormControl
                isInvalid={!!errors.lastName && touchedFields["lastName"]}
                className={ClassesEnum.FormField}
                data-tracking-id={getTrackingId(
                    [ClassesEnum.FormField],
                    "studentLastNameLabel"
                )}
            >
                <FormLabel>
                    {t(
                        "enrol.createStudentPage.lastNameLabel",
                        "Student's last name"
                    )}
                </FormLabel>
                <Input
                    id="lastName"
                    {...register("lastName")}
                    maxLength={50}
                    onChange={e => handleChange(e, setValue)}
                    data-testid="last-name-input"
                    className={ClassesEnum.Input}
                    data-tracking-id={getTrackingId(
                        [ClassesEnum.Input],
                        "studentlastName"
                    )}
                />
                <FormErrorMessage>
                    {t(errors.lastName?.message as string)}
                </FormErrorMessage>
            </FormControl>
        </>
    );
};

export default CreateStudentForm;
